<canvas
  #confettiCanvas
  class="confetti-canvas"
  (mousedown)="onCanvasClick($event)">
</canvas>

